import { TQuoteData } from '@xhype/card-app-sdk';
import { BASIC_TRANSFER_TOKEN_FUNCTIONS } from '@package/smart-wallet/constants';
import { ethers } from 'ethers';
import { Address, parseAbi } from 'viem';

/* Build transactions */
export const buildErc20ApproveTransaction = (
  targetAddress: Address,
  tokenAddress: Address,
  amount: string = '0',
  decimals: number = 18,
) => {
  const contractInterface = new ethers.Interface(
    BASIC_TRANSFER_TOKEN_FUNCTIONS,
  );

  const parseAmount = ethers.parseUnits(amount, decimals).toString();
  const transaction = {
    to: tokenAddress,
    data: contractInterface.encodeFunctionData('approve', [
      targetAddress,
      parseAmount,
    ]),
    value: '0',
    operation: 0,
  };

  return transaction;
};

// TODO-DIEGO: Use this to create the transaction
// Pass the amount in decimals with ., for example: 210.71
export const buildErc20TransferTransaction = (
  targetAddress: Address,
  tokenAddress: Address,
  amount: string = '0',
  decimals: number = 18,
) => {
  const contractInterface = new ethers.Interface(
    parseAbi(BASIC_TRANSFER_TOKEN_FUNCTIONS),
  );

  const parseAmount = ethers.parseUnits(amount, decimals).toString();
  const transaction = {
    to: tokenAddress,
    data: contractInterface.encodeFunctionData('transfer', [
      targetAddress,
      parseAmount,
    ]),
    value: '0',
    operation: 0,
  };

  return transaction;
};

/* Build native transfer transaction */
export const buildNativeTransferTransaction = (
  targetAddress: Address,
  amount: string = '0',
  decimals: number = 18,
) => {
  const parseAmount = ethers.parseUnits(amount, decimals).toString();
  const transaction = {
    to: targetAddress,
    data: '0x' as Address,
    value: BigInt(parseAmount),
    operation: 0,
  };

  return transaction;
};

/* Others */
export const waitFor = (seconds: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, seconds * 1000);
  });
};

export const parseTransaction = (transaction: TQuoteData[]) => {
  return transaction.map((item) => {
    return {
      to: item.to as Address,
      data: item.data,
      value: '0',
      operation: 0,
    };
  });
};
